import { isNonEmptyArray } from '../../../utils/checks'

const centerHasNoPricing = (center: {
  price: string[]
  [key: string]: unknown
}): boolean => !isNonEmptyArray(center.price)

export default centerHasNoPricing
